import { Birthdate, taxBracketOptions } from './kyc-schema';

export type QuestionType =
  | { type: 'text'; question: string; value: string }
  | { type: 'number'; question: string; value: number }
  | { type: 'date'; question: string; value: string } // ISO 8601 date string (YYYY-MM-DD)
  | { type: 'birthdate'; question: string; value: Birthdate | undefined }
  | { type: 'multipleChoice'; question: string; options: string[]; value: string[] | string; multiple?:boolean } //multiple indicates if multiple selections are allowed.
  | { type: 'choiceNumber'; question: string; options: { label: string; value: number }[]; value: number | undefined }
  | { type: 'slider'; question: string; min: number; max: number; value: number };

export const surveyQuestions = {
  fullName: { type: 'text', question: 'Name', value: '' },
  birthdate: { type: 'birthdate', question: 'Birthdate', value: undefined as Birthdate | undefined },
  retirementYear: { type: 'number', question: 'Target Retirement Year', value: new Date().getFullYear() },
  annualIncome: { type: 'number', question: 'Annual Income', value: 0 },
  accountTypes: { type: 'multipleChoice', question: 'Account Types Being Evaluated', options: ['Retirement', 'Non-Retirement'], value: [] as string[], multiple: true },
  retirementAssets: { type: 'number', question: 'Retirement Assets', value: 0 },
  nonRetirementAssets: { type: 'number', question: 'Non-Retirement Assets', value: 0 },
  totalAssets: { type: 'number', question: 'Total Assets', value: 0 },
  totalInvestments: { type: 'number', question: 'Total Investments', value: 0 },
  totalCash: { type: 'number', question: 'Total Cash and Cash Equivalents', value: 0 },
  totalLiabilities: { type: 'number', question: 'Total Liabilities', value: 0 },
  monthlyExpenses: { type: 'number', question: 'Total Monthly Expenses', value: 0 },
  liquidNetWorth: { type: 'number', question: 'Liquid Net Worth', value: 0 },
  investmentObjectives: { type: 'multipleChoice', question: 'Investment Objectives', options: ['Capital Appreciation', 'Growth', 'Speculation', 'Capital Preservation', 'Income', 'Tax-Advantage'], value: [] as string[], multiple: true },
  liquidityNeeds: { type: 'text', question: 'Liquidity Needs', value: '' },
  financialExperience: { type: 'slider', question: 'Financial Experience', min: 1, max: 10, value: 1 },
  riskTolerance: { type: 'multipleChoice', question: 'Risk Tolerance', options: ['Conservative', 'Moderately Conservative', 'Moderate', 'Moderately Aggressive', 'Aggressive'], value: '' },
  taxBracketValue: { type: 'choiceNumber', question: 'Tax Bracket', options: taxBracketOptions, value: undefined as number | undefined },
  shortTermGoal: { type: 'text', question: 'Short Term Financial Goal', value: '' },
  longTermGoals: { type: 'text', question: 'Top 3 Long Term Financial Goals', value: '' },
};

export type SurveyKeys = keyof typeof surveyQuestions;

export type SurveyAnswers = {
  [K in keyof typeof surveyQuestions]: typeof surveyQuestions[K]['value'];
};
